export default {
  isLoading: false,
  productGroup: null,

  isStoring: false,
  isValidatingProductGroupNumber: false,
};
